export const DASHBOARD_MENU_KEY = "dashboard";
export const INSTITUTES_MENU_KEY = "institutes";
export const APPLICATIONS_MENU_KEY = "applications";
export const APPLICATIONS_SCRUTINY_MENU_KEY = "applications-scrutiny";
export const APPLICATIONS_SCRUTINIZED_MENU_KEY = "applications-scrutinized";
export const APPLICATIONS_INSPECTED_MENU_KEY = "applications-inspected";
export const APPLICATIONS_REJECTED_MENU_KEY = "applications-rejected";
export const APPLICATIONS_REFERRED_BACK_MENU_KEY = "applications-referred-back";
export const APPLICATIONS_APPROVED_MENU_KEY = "applications-approved";
export const APPLICATIONS_PENDING_REJECTION_MENU_KEY = "applications-pending-rejection";
export const COMMITTEES_MENU_KEY = "committees";
export const CERTIFICATES_MENU_KEY = "certificates";
export const MEMBERS_MENU_KEY = "members";
export const COURSE_BUILDER_MENU_KEY = "course-builder";
export const APPEALS_MENU_KEY = "appeals";
export const CHALLAN_MENU_KEY = "challan";
export const MANAGE_USER_MENU_KEY = "Manage Users";
export const ROLES_AND_PERMISSIONS_MENU_KEY = "roles-and-permissions";
export const AUDIT_LOG_MENU_KEY = "audit-log";
export const CONFIGURATION_MENU_KEY = "configuration";
export const CONFIGURATION_COURSE_STREAM_MENU_KEY = "configuration-course-stream";
export const CONFIGURATION_ORGANIZATION_TYPE_MENU_KEY = "configuration-organization-type";
export const CONFIGURATION_COURSE_CONTENT_MENU_KEY = "configuration-course-content";
export const CONFIGURATION_FACULTY_QUALIFICATIONS_MENU_KEY = "configuration-faculty-qualifications";
export const CONFIGURATION_ATTACHMENT_TYPE_MENU_KEY = "configuration-attachment-type";
export const CONFIGURATION_ATTACHMENT_OPTION_MENU_KEY = "configuration-attachment-option";
export const CONFIGURATION_INSTITUTE_FACILITY_MENU_KEY = "configuration-institute-facility";
export const CONFIGURATION_COMPETENCY_POINTS_MENU_KEY = "configuration-competency-points";
export const CONFIGURATION_SECTORS_MENU_KEY = "configuration-sectors";
export const CONFIGURATION_COURSE_SCHEME_MENU_KEY = "configuration-course-scheme";
export const CONFIGURATION_ASSESSMENT_BODY_MENU_KEY = "configuration-assessment-body";
export const CALENDAR_MENU_KEY = "calendar";
export const MANAGE_SESSIONS_MENU_KEY = "manage-sessions";
export const REPORTS_MENU_KEY = "reports";
export const EMPLOYEE_ENDORSEMENT_MENU_KEY = "employee-endorsement";
export const REPORT_MODULE_MENU_KEY = "report-module";
export const TRACEABILITY_MENU_KEY = "traceability";
export const COMMITTEES_MY_MENU_KEY = "committees-my";
export const COMMITTEES_HISTORY_MENU_KEY = "committees-history";
export const COMMITTEES_REQUESTS_MENU_KEY = "committees-requests";
export const FAQ_MENU_KEY = "faq";
export const UNAUTHORIZED_INSTITUTES_MENU_KEY = "unauthorized-institutes";
export const APPRENTICESHIP_MENU_KEY = "apprenticeship";
export const APPRENTICESHIP_INDUSTRY_MENU_KEY = "apprenticeship-industry";
export const APPRENTICESHIP_APPRENTICES_MENU_KEY = "apprenticeship-apprentices";
export const APPRENTICESHIP_OUTCOMES_MENU_KEY = "apprenticeship-outcomes";
export const APPRENTICESHIP_STATISTICS_MENU_KEY = "apprenticeship-statistics";

import {
	EVENT_MANAGEMENT_MENU_KEY,
	EVENT_CREATION_MENU_KEY,
	EVENTS_REQUEST_MENU_KEY,
	EVENTS_CLONE_MENU_KEY,
} from "@features/EventManagement/integration/menu.keys";
import { COURSE_ASSIGN_MENU_KEY, COURSE_ASSIGN_ASSIGN_MENU_KEY, SPECIAL_INITIATIVE_COURSES_MENU_KEY } from "@features/CourseAssign/integration/menu.keys";

export { EVENT_MANAGEMENT_MENU_KEY, EVENT_CREATION_MENU_KEY, EVENTS_REQUEST_MENU_KEY, EVENTS_CLONE_MENU_KEY, COURSE_ASSIGN_MENU_KEY, COURSE_ASSIGN_ASSIGN_MENU_KEY, SPECIAL_INITIATIVE_COURSES_MENU_KEY };

export type SidebarMenuKey =
	| typeof DASHBOARD_MENU_KEY
	| typeof INSTITUTES_MENU_KEY
	| typeof APPLICATIONS_MENU_KEY
	| typeof APPLICATIONS_SCRUTINY_MENU_KEY
	| typeof APPLICATIONS_SCRUTINIZED_MENU_KEY
	| typeof APPLICATIONS_INSPECTED_MENU_KEY
	| typeof APPLICATIONS_REJECTED_MENU_KEY
	| typeof APPLICATIONS_REFERRED_BACK_MENU_KEY
	| typeof APPLICATIONS_APPROVED_MENU_KEY
	| typeof APPLICATIONS_PENDING_REJECTION_MENU_KEY
	| typeof COMMITTEES_MENU_KEY
	| typeof COMMITTEES_MY_MENU_KEY
	| typeof COMMITTEES_HISTORY_MENU_KEY
	| typeof COMMITTEES_REQUESTS_MENU_KEY
	| typeof CERTIFICATES_MENU_KEY
	| typeof MEMBERS_MENU_KEY
	| typeof CHALLAN_MENU_KEY
	| typeof COURSE_BUILDER_MENU_KEY
	| typeof APPEALS_MENU_KEY
	| typeof CALENDAR_MENU_KEY
	| typeof MANAGE_SESSIONS_MENU_KEY
	| typeof REPORTS_MENU_KEY
	| typeof EMPLOYEE_ENDORSEMENT_MENU_KEY
	| typeof REPORT_MODULE_MENU_KEY
	| typeof TRACEABILITY_MENU_KEY
	| typeof MANAGE_USER_MENU_KEY
	| typeof ROLES_AND_PERMISSIONS_MENU_KEY
	| typeof AUDIT_LOG_MENU_KEY
	| typeof CONFIGURATION_MENU_KEY
	| typeof CONFIGURATION_COURSE_STREAM_MENU_KEY
	| typeof CONFIGURATION_ORGANIZATION_TYPE_MENU_KEY
	| typeof CONFIGURATION_COURSE_CONTENT_MENU_KEY
	| typeof CONFIGURATION_FACULTY_QUALIFICATIONS_MENU_KEY
	| typeof CONFIGURATION_ATTACHMENT_TYPE_MENU_KEY
	| typeof CONFIGURATION_ATTACHMENT_OPTION_MENU_KEY
	| typeof CONFIGURATION_INSTITUTE_FACILITY_MENU_KEY
	| typeof CONFIGURATION_COMPETENCY_POINTS_MENU_KEY
	| typeof CONFIGURATION_SECTORS_MENU_KEY
	| typeof CONFIGURATION_COURSE_SCHEME_MENU_KEY
	| typeof FAQ_MENU_KEY
	| typeof UNAUTHORIZED_INSTITUTES_MENU_KEY
	| typeof APPRENTICESHIP_MENU_KEY
	| typeof APPRENTICESHIP_STATISTICS_MENU_KEY
	| typeof APPRENTICESHIP_INDUSTRY_MENU_KEY
	| typeof APPRENTICESHIP_APPRENTICES_MENU_KEY
	| typeof APPRENTICESHIP_OUTCOMES_MENU_KEY
	| typeof EVENT_MANAGEMENT_MENU_KEY
	| typeof EVENT_CREATION_MENU_KEY
	| typeof EVENTS_REQUEST_MENU_KEY
	| typeof EVENTS_CLONE_MENU_KEY
	| typeof COURSE_ASSIGN_MENU_KEY
	| typeof COURSE_ASSIGN_ASSIGN_MENU_KEY
	| typeof SPECIAL_INITIATIVE_COURSES_MENU_KEY;
